/**
 * Free US shipping progress toward $299 (retail) (cart page + ajax cart modal).
 * Threshold matches Admin free-shipping condition; does not change rates.
 */
(function () {
  var THRESHOLD_CENTS = 29900;

  function moneyLabel(cents) {
    var dollars = cents / 100;
    if (Math.abs(dollars - Math.round(dollars)) < 0.001) {
      return '$' + Math.round(dollars);
    }
    return '$' + dollars.toFixed(2);
  }

  function compute(totalCents) {
    var total = typeof totalCents === 'number' ? totalCents : 0;
    if (total <= 0) {
      return {
        done: false,
        pct: 0,
        msg: 'Free US shipping on retail orders $299+',
        hide: true
      };
    }
    if (total >= THRESHOLD_CENTS) {
      return {
        done: true,
        pct: 100,
        msg: "You've unlocked free US shipping!",
        hide: false
      };
    }
    var remaining = THRESHOLD_CENTS - total;
    var pct = Math.max(0, Math.min(99, Math.round((total / THRESHOLD_CENTS) * 100)));
    return {
      done: false,
      pct: pct,
      msg: 'Add ' + moneyLabel(remaining) + ' more for free US shipping',
      hide: false
    };
  }

  function paint(el, totalCents) {
    var state = compute(totalCents);
    if (state.hide) {
      el.hidden = true;
      return;
    }
    el.hidden = false;
    el.classList.toggle('ff-fs-progress--done', state.done);
    var text = el.querySelector('.ff-fs-progress__text');
    var fill = el.querySelector('.ff-fs-progress__fill');
    if (text) text.textContent = state.msg;
    if (fill) fill.style.width = state.pct + '%';
  }

  function updateAll(cart) {
    var total = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
    var nodes = document.querySelectorAll('[data-ff-fs-progress]');
    for (var i = 0; i < nodes.length; i++) {
      paint(nodes[i], total);
    }
  }

  function refresh() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(updateAll)
      .catch(function () {});
  }

  function observeAjaxCart() {
    if (!window.MutationObserver) return;
    var target = document.getElementById('ajaxifyCart');
    if (!target) return;
    var timer = null;
    var mo = new MutationObserver(function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(refresh, 50);
    });
    mo.observe(target, { childList: true, subtree: true });
  }

  function bindAjaxHooks() {
    if (!window.jQuery) return;
    jQuery(document).ajaxComplete(function (_e, _xhr, settings) {
      var url = (settings && settings.url) || '';
      if (/\/cart(\.js|\/add|\/change|\/update|\/clear)?/i.test(url)) {
        refresh();
      }
    });
  }

  function init() {
    refresh();
    observeAjaxCart();
    bindAjaxHooks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
